import _each from 'lodash/each';
import _isArray from 'lodash/isArray';

import {executeHtmlHooks} from "../utils/htmlHooks";

function loadContent(element, doneCallback) {
    // return;
    if (element.dataset.load) {
        const url = element.dataset.load;
        delete element.dataset.load; // after getting the url out of the dataset, remove the property, so it won't load again

        window.axios.get(url).then(({data: html}) => {
            $(element).html(html);

            executeHtmlHooks(element);

            // when we have a done callback, trigger it and pass current element.
            if (typeof doneCallback == 'function') {
                doneCallback(element);
            }
        });
    }
}

/**
 * load contents for given elements or element, (data-load must be present)
 * @param {Array<Object>, Object} elements
 * @param {function=} doneCallback
 */
const loadContents = function(elements, doneCallback) {
    if (_isArray(elements) || elements instanceof NodeList) {
        _each(elements, (el) => loadContent(el, doneCallback));
    } else {
        loadContent(elements, doneCallback);
    }
}

const contentsToLoad = document.querySelectorAll('[data-load-contents]');

if (contentsToLoad.length > 0) {
    loadContents(contentsToLoad);
}

export default loadContents
